import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  buttonPrimary: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    height: 35,
    borderColor: theme.palette.Primary.background,
    marginRight: 15,
    fontWeight: 400,
    color: theme.palette.background.white,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      borderColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  closeIcon: {
    position: "absolute",
    zIndex: 999,
    right: 40,
    top: 20,
    cursor: "pointer",
  },
  button: {
    height: "48px",
    width: "80%",
  },
  popUp: {
    margin: "auto",
  },
  buttonContainerReview: {
    display: "flex",
    justifyContent: "flex-start",
    gap: 5,
    paddingTop: 20,
    paddingBottom: 15,
  },
  buttonSecondary: {
    color: theme.palette.Primary.background,
    borderColor: theme.palette.Primary.background,
    textTransform: "capitalize",
    "&:hover": {
      borderColor: theme.palette.Primary.background,
      backgroundColor: theme.palette.Primary.contrastText,
    },
    marginRight: theme.spacing(5),
  },
  dialog: {
    width: "60% !important",
    textAlign: "center",
  },
  viewButton: {
    display: "flex",
    paddingTop: "14px",
    marginBottom: "22px",
  },
  autoComplete: {
    width: "100%",
    marginRight: theme.spacing(4),
  },
  autoCompleteOption: {
    textAlign: "left", // Ensure text is aligned to the left
    whiteSpace: "normal", // Allows text to wrap if it's long
    display: "flex", // Maintains consistent alignment for multi-line items
  },
  root: {
    "& label.Mui-focused": {
      color: theme.palette.Primary.main,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: theme.palette.Primary.main,
    },
    "& .MuiInput-root:hover::before": {
      borderWidth: 1,
      borderBottomColor: theme.palette.Primary.main,
    },
    "& .MuiFilledInput-root:hover::before": {
      borderBottomColor: theme.palette.Primary.main,
    },
    "& .MuiFilledInput-underline:after": {
      borderColor: theme.palette.Primary.main,
    },
    "& .MuiOutlinedInput-root": {
      height: "50px !important",
      "& fieldset": {
        borderColor: theme.palette.Primary.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.Primary.main,
      },
      "&.Mui-focused fieldset": {
        borderWidth: 2,
        borderColor: theme.palette.Primary.main,
      },
    },
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& .css-czrb7a-MuiFormLabel-root-MuiInputLabel-root,.css-kyi7ki-MuiFormLabel-root-MuiInputLabel-root.Mui-focused":
      {
        color: theme.palette.Primary.main,
      },
  },
  input: {
    "& .css-r5s6a1-MuiInputBase-root-MuiOutlinedInput-root": {
      height: "50px !important",
    },
    "& .css-g7hdyn-MuiFormHelperText-root.Mui-error": {
      margin: `${theme.spacing(0, 0, 3, 0)} !important`,
    },
    "& .MuiFormControl-root > .MuiInputBase-root > input": {
      backgroundColor: "white !important",
    },
  },
  inputWithoutMargin: {
    margin: "4px 0px",
    "& .css-r5s6a1-MuiInputBase-root-MuiOutlinedInput-root": {
      height: "50px !important",
    },
    "& .css-g7hdyn-MuiFormHelperText-root.Mui-error": {
      margin: `${theme.spacing(0, 0, 3, 0)} !important`,
    },
    "& .MuiFormControl-root > .MuiInputBase-root > input": {
      backgroundColor: "white !important",
    },
  },
  popupTitle: {
    fontWeight: 600,
    paddingTop: theme.spacing(8),
  },
  choiceTitle: {
    fontWeight: 600,
    textAlign: "left",
  },
  eachIndustryBox: {
    border: "1px solid rgba(139, 33, 71, 1)",
    padding: "10px",
    borderRadius: "4px",
    background: "#e4e4e445",
  },
  diffrenciater: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 12,
    marginTop: 12,
    marginBottom: 8,
  },

  line: {
    flex: 1,
    height: 1,
    backgroundColor: "#C9BFC0",
    opacity: 0.9,
  },

  orDiv: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px 8px",
    borderRadius: 12,
    border: "1px solid #C9BFC0",
    backgroundColor: "#ffffff",
    minWidth: 36,
    height: 20,
    boxSizing: "border-box",
  },

  orText: {
    fontSize: 10,
    lineHeight: "11px",
    fontWeight: 500,
    color: "#6b3a44",
    letterSpacing: 0.4,
    textAlign: "center",
  },

  tabLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  tabTitle: {
    marginLeft: 8,
    marginRight: 6,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
  buttonTeritory: {
    background: "#bbaeb2",
    textTransform: "capitalize",
    height: 35,
    borderColor: "#8C2148",
    marginRight: 15,
    fontWeight: 400,
    color: "#8C2148",
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      borderColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  uploadButtonDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    minHeight: "80px",
    justifyContent: "space-between",
  },
  customFileUpload: {
    border: "1px solid #ccc",
    display: "inline-block",
    padding: "6px 12px",
    cursor: "pointer",
  },
  hideFile: {
    display: "None",
  },
  uploadButton: {
    background: theme.palette.Primary.background,
    textTransform: "capitalize",
    borderColor: theme.palette.Primary.background,
    marginRight: 15,
    fontWeight: 400,
    padding: "3px 0px",
    width: "100%",
    borderRadius: "5px",
    color: theme.palette.background.white,
    "&:hover": {
      backgroundColor: theme.palette.Primary.hoverButton,
      borderColor: theme.palette.Primary.hoverButton,
      color: theme.palette.Primary.light,
    },
  },
  tableContainer: {
    border: "1px solid black",
  },
  tableDiv: {
    height: "200px" /* Or max-height */,
    overflowY: "auto",
    width: "100%",
    padding: "10px 10px",
    marginTop: "10px",
  },
}));

export default useStyles;
